/**
 * Communications flow library — types + helpers (Greg's flow-naming work).
 *
 * #635 seed-guard (2026-07-08 merge): the example-flow seed rows were removed —
 * the array below is EMPTY in app source. Example flows are the mock layer's
 * to serve via listBuilderFlows (REQ-002 resolved).
 */
import type { FBFlow } from "../builder/fb-model";
import { t as i18nT } from "../../lib/i18n";

export interface SeedFlow extends FBFlow {
  id: string;
  name: string;
  eventKind: string;
  desc: string;
}

// #635: baked flow library removed — served via listBuilderFlows /
// @v0y4ge/api-mocks (REQ-002).

export const FLOW_KIND_PILL: Record<string, { label: string; labelKey: string; tone: "primary" | "success" | "warn" }> = {
  invite: { labelKey: "messaging.flowsSeed.invitationEvent", get label() { return i18nT("messaging.flowsSeed.invitationEvent"); }, tone: "primary" },
  public: { labelKey: "messaging.flowsSeed.publicEvent", get label() { return i18nT("messaging.flowsSeed.publicEvent"); }, tone: "success" },
  private: { labelKey: "messaging.flowsSeed.privateEvent", get label() { return i18nT("messaging.flowsSeed.privateEvent"); }, tone: "warn" },
  queue: { labelKey: "messaging.flowsSeed.queue", get label() { return i18nT("messaging.flowsSeed.queue", "Queue"); }, tone: "success" },
  appointment: { labelKey: "messaging.flowsSeed.appointment", get label() { return i18nT("messaging.flowsSeed.appointment", "Appointment"); }, tone: "primary" },
};

export function flowStats(f: { steps?: any[] }): { steps: number; messages: number; decisions: number } {
  let steps = 0, messages = 0, decisions = 0;
  const walk = (arr?: any[]) => (arr || []).forEach((s) => {
    steps++;
    if (s.kind === "comms") messages++;
    else if (s.kind === "decision") { decisions++; walk(s.yes); walk(s.no); }
  });
  walk(f.steps);
  return { steps, messages, decisions };
}
